export const iconFontAwesomeLogisticsTruckFast = (
	<i className="fa-solid fa-truck-fast"></i>
);
